import { ALL_INTEGRATIONS, BRANCH_INTEGRATIONS, expandIntegrationKeys } from "./integrations";

export const VAT = 0.15;

export const monthNames = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  10: "October",
  11: "November",
  12: "December",
  JAN: "January",
  FEB: "February",
  MAR: "March",
  APR: "April",
  MAY: "May",
  JUN: "June",
  JUL: "July",
  AUG: "August",
  SEP: "September",
  OCT: "October",
  NOV: "November",
  DEC: "December",
  JANUARY: "January",
  FEBRUARY: "February",
  MARCH: "March",
  APRIL: "April",
  JUNE: "June",
  JULY: "July",
  AUGUST: "August",
  SEPTEMBER: "September",
  OCTOBER: "October",
  NOVEMBER: "November",
  DECEMBER: "December",
};

// Canonical integration keys offered for a store's accounts and for a
// branch's apps/users (utils/integrations.js).
export const availableApps = ALL_INTEGRATIONS;
export const branchAvailableApps = BRANCH_INTEGRATIONS;

export const formatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
export const formatter2 = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const statuses = [
  "canceled",
  "rejected",
  "completed",
  "endurance",
  "refund",
];

export const BASIC_FILTER = {
  app: [],
  store: [],
  branch: [],
  status: [],
  month: [],
  year: [],
};

export const createServiceChargePercent = ({
  completedAmount,
  serviceCharge,
  offers,
  deliveryOffer,
}) => {
  return completedAmount > 0
    ? (
        (serviceCharge / (completedAmount - offers - deliveryOffer)) *
        100 *
        1.15
      ).toFixed(2)
    : 0;
};
export const createGrantTotalPercent = ({
  completedAmount,
  grandTotal,
  offers,
}) => {
  return completedAmount > 0
    ? (100 - (grandTotal / (completedAmount - offers)) * 100).toFixed(2)
    : 0;
};

// Brand color per canonical key; every known spelling resolves too.
export const APP_COLORS = expandIntegrationKeys({
  jahez: "#e11a2f",
  toyou: "#003462",
  hungerstation: "#fac602",
  keeta: "#ffd100",
  noonfood: "#deff5c",
  ninja: "#1dcad2",
  marsool: "#00bf63",
  thechefz: "#62000d",
  mrmandoob: "#2c884c",
  LUD: "#644672",
});
